// extracted by mini-css-extract-plugin
module.exports = {"normal":"Index_normal__xitf5","normalM":"Index_normalM__cUJCx","animationFade":"Index_animationFade__2QKV6"};